export const environment = {
  production: false,
  auth: {
    clientId: 'c301e763-27be-45ab-88f5-f0c9934f6115',
    tenantId: '1a47d566-67d6-448f-93dc-19565d759c26',
    apiScope: 'api://d167bee1-6caf-4fa7-94dc-548fcec062c6/.default',
  },
};
